import React from 'react'
import BtnPlay from '@components/app/button-play'
import PlayerCtx from '@data/contexts/player'
import { AlbumProps } from '../../../../types/album'
import { API_HOST } from '../../../config'
import styles from '../media.module.scss'

interface Props {
  album: AlbumProps
  index: number
  disabled?: boolean
  className?: string
  size?: string
  // tracks: any,
  isAll?: boolean
}

const PlayAllBtn = ({
  album,
  index,
  className = '',
  disabled = false,
  size = '3.5rem',
  // tracks,
  isAll = false,
}: Props) => {
  const {
    isLoading,
    isPlaying,
    nowPlaying,
    play,
    pause,
    setPlaylist,
  } = PlayerCtx.useContainer()

  const isThis = isAll
    ? album.sounds.filter((s) => s.id === nowPlaying.track?.id).length > 0
    : nowPlaying.track?.id === album.sounds[index].id

  const onClick = () => {
    if (isThis && isPlaying) {
      pause()
      return
    }

    const list = album.sounds.map((sound) => ({
      id: sound.id,
      albumId: album.id,
      title: sound.title,
      creatorId: album.id,
      slug: sound.slug,
      user: album.user.name,
      coverart: sound.coverart_crop_url,
      waveformUrl: sound.waveform_url,
      duration: sound.metadata?.duration,
      webmUrl: `${API_HOST}/sounds/${sound.id}.webm`,
      mp3Url: `${API_HOST}/sounds/${sound.id}.mp3`,
      hlsUrl: `${API_HOST}/sounds/${sound.id}.m3u8`,
      limit: sound.limit,
    }))

    if (!isThis) {
      setPlaylist({
        name: album.title,
        path: `album/${album.id}`,
        list,
      })
    }

    play(list[index])
  }

  return (
    <BtnPlay
      size={size}
      className={`${styles.headingPlayBtn} ${className}`}
      isLoading={isThis && isLoading}
      isPlaying={isThis && isPlaying}
      onClick={onClick}
      disabled={disabled}
    />
  )
}

export default PlayAllBtn
